export const APP_CONSTANTS = {
  ADDRESS_PATTERN: /^[A-Za-z'\.\-\s]+$/,
  BUILDING_PATTERN: /^[0-9\/'\-\s]+$/,
  FLOAT_LOCALE_AGNOSTIC: /^[0-9]+([\.\,][0-9]{1,2})?$/,
  LANDLINE_PATTERN: /^(?:00|0|\+)[0-9]+$/,
  IBAN_PATTERN: /^[A-Z]{2}[0-9]{2}(?:[ ]?[0-9]{4}){4}(?:[ ]?[0-9]{1,2})?$/,
  BIC_PATTERN: /([a-zA-Z]{4})([a-zA-Z]{2})(([2-9a-zA-Z]{1})([0-9a-np-zA-NP-Z]{1}))((([0-9a-wy-zA-WY-Z]{1})([0-9a-zA-Z]{2}))|([xX]{3})|)/
};
